import { useTranslation } from 'libs/i18n'

export const useSortingFilters = () => {
	const { t } = useTranslation()

	return {
		id: 'ordering',
		label: t('Sort by'),
		placeholder: t('Default'),
		options: [
			{
				value: 'status',
				label: `${t('Status')} asc`
			},
			{
				value: '-status',
				label: `${t('Status')} desc`
			},
			{
				value: 'ref_nr',
				label: `${t('Reference')} asc`
			},
			{
				value: '-ref_nr',
				label: `${t('Reference')} desc`
			}
		]
	}
}
